import * as React from "react";
function SvgIcArrowRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.002 19L20 12l-3.998-7-.64.373 3.573 6.254H4v.746h14.935l-3.573 6.254.64.373z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcArrowRight;
